import { enumRoles, enumPermissions as permission } from "data/enums/authorization";
import { moduleNames } from "data/enums/modules";

const { ADMIN, MANAGER, ADVERTISER, SUPPORT, FINANCE } = enumRoles

const allRoles = [ADMIN, MANAGER, ADVERTISER, SUPPORT, FINANCE]
const allAdminRoles = [ADMIN, MANAGER, SUPPORT, FINANCE]
// const [AFFILIATE] = [AFFILIATE];
// const allUserRoles = [ADVERTISER, AFFILIATE]
const advertiserRoles = [ADVERTISER]

const routes = [
  {
    id: 'admin',
    auth: {
      roles: allAdminRoles
    },
    modules: [
      {
        id: moduleNames.ADMIN_DASHBOARD, to: '/admin/dashboard',
        auth: { roles: allAdminRoles, permissions: [permission.ADMIN_DASHBOARD_CHART], home: true },
      },
      {
        id: moduleNames.ADMIN_STATS_REPORT, to: '/admin/report',
        auth: { roles: allAdminRoles, permissions: [permission.ADMIN_STATS_REPORT] },
      },
      {
        id: moduleNames.ADMIN_OVERVIEW_DROPDOWN, to: '/admin/overview',
        auth: { roles: allAdminRoles, permissions: [permission.ADMIN_OVERVIEW_COUNTRIES] },
        routes: [
          {
            id: moduleNames.ADMIN_OVERVIEW_COUNTRIES, to: '/admin/overview/countries',
            auth: { roles: allAdminRoles, permissions: [permission.ADMIN_OVERVIEW_COUNTRIES] },
          }
        ]
      },
      {
        id: moduleNames.ADMIN_CAMPAIGNS, to: '/admin/campaigns',
        auth: { roles: allAdminRoles, permissions: [permission.ADMIN_CAMPAIGNS_LIST] },
      },

      {
        id: moduleNames.ADMIN_UNAPPROVED_CREATIVES, to: '/admin/unapproved-creatives',
        auth: { roles: allAdminRoles, permissions: [permission.ADMIN_UNAPPROVED_CREATIVES_LIST] },
      },

      {
        id: moduleNames.ADMIN_GROUPS, to: '/admin/groups',
        auth: { roles: allAdminRoles, permissions: [permission.ADMIN_GROUPS_LIST] },
      },
      {
        id: moduleNames.ADMIN_BIDS, to: '/admin/bids',
        auth: { roles: allAdminRoles, permissions: [permission.ADMIN_BIDS_LIST] },
      },
      {
        id: moduleNames.ADMIN_TOPUPS, to: '/admin/topups',
        auth: { roles: allAdminRoles, permissions: [permission.ADMIN_TOPUPS_LIST] },
      },
      {
        id: moduleNames.ADMIN_RECOMMENDED_CPC, to: '/admin/recommended-cpc',
        auth: { roles: allAdminRoles, permissions: [permission.ADMIN_RECOMMENDED_CPC_LIST] },
      },
      {
        id: moduleNames.ADMIN_LOGS_DROPDOWN, to: '/admin/logs',
        auth: { roles: allAdminRoles, permissions: [permission.ADMIN_LOGS_QUEUE_EMAIL] },
        routes: [
          {
            id: moduleNames.ADMIN_LOGS_QUEUE_EMAIL, to: '/admin/logs/queue-email',
            auth: { roles: allAdminRoles, permissions: [permission.ADMIN_LOGS_QUEUE_EMAIL] },
          }
        ]
      },
      {
        id: moduleNames.ADMIN_CHANGELOG, to: '/admin/change-log',
        auth: { roles: allAdminRoles, permissions: [permission.ADMIN_CHANGELOG_LIST] },
      },
      {
        id: moduleNames.ADMIN_USERS_DROPDOWN, to: '/admin/users',
        auth: { roles: allAdminRoles, permissions: [permission.ADMIN_USERS_LIST] },
        routes: [
          {
            id: moduleNames.ADMIN_USERS_LIST, to: '/admin/users/list',
            auth: { roles: allAdminRoles, permissions: [permission.ADMIN_USERS_LIST] },
          },
          {
            id: moduleNames.ADMIN_UNAPPROVED_USERS, to: '/admin/users/unapproved',
            auth: { roles: allAdminRoles, permissions: [permission.ADMIN_UNAPPROVED_USERS_LIST] },
          },
          {
            id: moduleNames.ADMIN_USERS_BALANCE, to: '/admin/users/balance',
            auth: { roles: allAdminRoles, permissions: [permission.ADMIN_USERS_BALANCE_LIST] },
          },
        ]
      },
      {
        id: moduleNames.ADMIN_LOGIN_HISTORY, to: '/admin/login-history',
        auth: { roles: allAdminRoles, permissions: [permission.ADMIN_LOGIN_HISTORY_LIST] },
      },
    ]
  },
  {
    id: 'advertiser',
    auth: {
      roles: [ADVERTISER]
    },
    modules: [
      {
        id: moduleNames.ADVERTISER_DASHBOARD, to: '/advertiser/dashboard',
        auth: { roles: [ADVERTISER], permissions: [], permissionsExclude: true },
      },
      {
        id: moduleNames.ADVERTISER_CAMPAIGNS, to: '/advertiser/campaigns',
        auth: { roles: [ADVERTISER], permissions: [], permissionsExclude: true },
      },
      {
        id: moduleNames.ADVERTISER_CREATIVES, to: '/advertiser/creatives',
        auth: { roles: [ADVERTISER], permissions: [], permissionsExclude: true },
      },
      {
        id: moduleNames.ADVERTISER_TOPUPS, to: '/advertiser/topups',
        auth: { roles: [ADVERTISER], permissions: [], permissionsExclude: true },
      },
      {
        id: moduleNames.ADVERTISER_STATS_REPORT, to: '/advertiser/report',
        auth: { roles: [ADVERTISER], permissions: [], permissionsExclude: true },
      },
      {
        id: moduleNames.ADVERTISER_TRACKING, to: '/advertiser/tracking',
        auth: { roles: [ADVERTISER], permissions: [], permissionsExclude: true },
      },
      {
        id: moduleNames.ADVERTISER_LOGIN_HISTORY, to: '/advertiser/login-history',
        auth: { roles: [ADVERTISER], permissions: [], permissionsExclude: true },
      },
    ]
  },

  {
    id: 'system',
    auth: {
      roles: allRoles
    },
    modules: [
      {
        id: moduleNames.ADMIN_PROFILE, to: '/admin/profile',
        auth: { roles: allAdminRoles, presmissions: [] },
      },
      {
        id: moduleNames.ADVERTISER_PROFILE, to: '/advertiser/profile',
        auth: { roles: [ADVERTISER], presmissions: [] },
      },
    ]
  },

]

if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_STAGING !== 'true') {
  const devRoutes = {
    id: 'dev',
    auth: {
      roles: allRoles
    },
    modules: [
      {
        id: `${moduleNames.DEV_BUILDER_DROPDOWN}_admin`, to: '/admin/builder',
        auth: { roles: allAdminRoles, permissions: [] },
        routes: [
          {
            id: `${moduleNames.DEV_BUILDER_MODULE}_admin`, to: '/admin/builder/module',
            auth: { roles: allAdminRoles, permissions: [] },
          }
        ]
      },
      {
        id: `${moduleNames.DEV_BUILDER_DROPDOWN}_adv`, to: '/advertiser/builder',
        auth: { roles: [ADVERTISER], permissions: [] },
        routes: [
          {
            id: `${moduleNames.DEV_BUILDER_MODULE}_adv`, to: '/advertiser/builder/module',
            auth: { roles: [ADVERTISER], permissions: [] },
          }
        ]
      }
    ]
  }
  routes.push(devRoutes)
}


export default routes